export const QA_NAME_MISSING_VARIABLES = 'missingVariables'

export const EDIT_VARIABLES = 'editVariables'

export const DELETE_RECIPIENTS = 'deleteRecipient'

export const DELETE_DOCUMENT_TEMPLATE = 'deleteDocumentTemplate'

export const QA_NAME_VIEW_REPORT_BUTTON = 'report'

export const QA_NAME_YES_BUTTON = 'yes'
